import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import type { SpendFilters, SpendStatus, SpendType } from '@/features/accounting-spend/api'
import { SpendListScreen } from '@/features/accounting-spend/spend-list-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/expenses/')({
  validateSearch: (search: Record<string, unknown>): SpendFilters => ({
    type: isSpendType(search.type) ? search.type : undefined,
    status: isSpendStatus(search.status) ? search.status : undefined,
    print_later:
      search.print_later === true || search.print_later === '1' || search.print_later === 'true'
        ? true
        : undefined,
    from: typeof search.from === 'string' ? search.from : undefined,
    to: typeof search.to === 'string' ? search.to : undefined,
    payee: typeof search.payee === 'string' ? search.payee : undefined,
    payment_account:
      typeof search.payment_account === 'string' ? search.payment_account : undefined,
    search: typeof search.search === 'string' ? search.search : undefined,
  }),
  beforeLoad: ({ context, search }) => {
    if (!hasGrant(context.queryClient, 'accounting_money_document.view')) {
      throw redirect({ to: '/accounting', search })
    }
  },
  component: ExpensesRoute,
})

function ExpensesRoute() {
  const navigate = useNavigate({ from: Route.fullPath })
  return (
    <SpendListScreen
      params={Route.useSearch()}
      onParamsChange={(search) => {
        // Let Radix finish closing its portal before this route remounts.
        setTimeout(() => void navigate({ to: '/accounting/expenses', search }), 0)
      }}
    />
  )
}

const isSpendType = (value: unknown): value is SpendType =>
  typeof value === 'string' && ['expense', 'card_credit'].includes(value)
const isSpendStatus = (value: unknown): value is SpendStatus =>
  typeof value === 'string' && ['draft', 'posted', 'void'].includes(value)
